import { graphql } from '@/graphql-setup'

export const PATCH_WORK_INFRINGEMENT_WRONGLY_GENERATED = graphql(`
  mutation PatchWorkInfringementWronglyGenerated(
    $id: ID!
    $wronglyGenerated: Boolean!
    $explanation: String
  ) {
    patchWorkInfringementWronglyGenerated(
      id: $id
      wronglyGenerated: $wronglyGenerated
      explanation: $explanation
    ) {
      workInfringement {
        id
        wronglyGenerated
        wronglyGeneratedExplanation
      }
    }
  }
`)
